import isNil from 'lodash-es/isNil';

type Strategy = '3month';
export class Price {
  private price: number | null;
  private currencySymbol: string;
  private currencyIso: string;
  constructor({
    price,
    currencySymbol,
    currencyIso,
  }: {
    price: number | null;
    currencySymbol: string;
    currencyIso: string;
  }) {
    this.price = price;
    this.currencySymbol = currencySymbol;
    this.currencyIso = currencyIso;
  }
  static formatDisplayPrice({
    price,
    currencySymbol = '',
    currencyIso = '',
  }: {
    price: number | null;
    currencySymbol?: string;
    currencyIso?: string;
  }) {
    if (price === null) {
      return null;
    }
    const displayPrice = `${currencySymbol}${price}`;
    if (
      Price.isCurrencyISORequired({
        currencySymbol,
        currencyIso,
      })
    ) {
      return `${currencyIso} ${displayPrice}`;
    }
    return displayPrice;
  }

  displayPrice(): null | string {
    return Price.formatDisplayPrice({
      price: this.price,
      currencySymbol: this.currencySymbol,
      currencyIso: this.currencyIso,
    });
  }

  static isCurrencyISORequired({
    currencySymbol,
    currencyIso,
  }: {
    currencySymbol: string;
    currencyIso: string;
  }): boolean {
    return currencySymbol === '$' && currencyIso !== 'USD' && currencyIso !== '';
  }

  static formatNumberPrice(price: number): string {
    return new Intl.NumberFormat('en-IN', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price);
  }
  static round(price: number, params: { strategy?: Strategy } = {}): number {
    if (params?.strategy === '3month') {
      return Math.ceil(price);
    }
    return Math.floor(price);
  }
  static getSavingsPercentage(regularPrice: number | null, discountPrice: number | null): number {
    if (isNil(regularPrice) || isNil(discountPrice)) {
      return 0;
    }
    const savingsPercentage = Math.round(((regularPrice - discountPrice) / regularPrice) * 100);
    return savingsPercentage;
  }
}
